<template>
  <div class='modal-container' style='width: 1000px'>
    <div class='modal-header fl'>
      <h3>Arbeidsverhouding Historie</h3>
    </div>

    <div class='modal-body hf'>
      <div class='hf' style='margin-bottom: -20px; margin-top: -25px;'>
        <v-data-table class='hf'
          :headers="headers"
          :items="modalData.relationship.employmentRelationshipDetails"
          :loading="false"
          :search="search"
          :pagination.sync="pagination"
          :rows-per-page-items="[5]"
          rows-per-page-text='Rijen per pagina'>
          <v-progress-linear slot='progress' color='#cdd2dc' indeterminate></v-progress-linear>
          <template slot='items' slot-scope='props'>
            <tr>
              <td>{{ formatDate(props.item.fromDate) }}</td>
              <td>{{ formatCurrency(props.item.grossAnnualSalary) }}</td>
              <td v-if="isShowingExtras">{{ formatCurrency(props.item.svSalary)}}</td>
              <td>{{ 'nature-of-employment.'+props.item.natureOfEmployment | translate }}</td>
              <td>{{ 'profession-classification.'+props.item.professionClassification | translate  }}</td>
              <td>{{ props.item.noRisk | translate }}</td>
            </tr>
          </template>

          <div class='no-results-badge' slot='no-results'>
            <v-icon>warning</v-icon>
            <p>{{ 'errors.no-results-found-for' | translate }}
              <span>{{ search }}</span>.
            </p>
          </div>
        </v-data-table>
      </div>
    </div>

    <div class='modal-footer'>
      <div style="float: right;">
        <Button gray @click="this.handleClose">{{ 'buttons.close' | translate }}</Button>
      </div>
      <div style='clear: both;' />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Helpers from '@/shared/helpers/functions';
import Modal from '@/shared/constants/modal';
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import Compositions from '@/views/helpers/compositions';

export default {
  name: 'EmployeeEmploymentRelationshipDetailsHistory',
  components: {
    Button
  },
  props: {
    modalData: null
    /* modalData: {
      employee: Employee,
      relationship: EmployeeEmploymentRelationship
    } */
  },
  data () {
    return {
      search: '',
      pagination: {
        sortBy: 'fromDate',
        descending: true,
        rowsPerPage: 5
      }
    };
  },

  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date),
    formatCurrency: (val) => Helpers.Currency.formatCurrency(val),

    handleClose () {
      this.$store.dispatch(Modal.Actions.CLOSE);
    }
  },

  computed: {
    headers () {
      return this.isShowingExtras ? [
        { text: 'Ingangsdatum', value: 'fromDate' },
        { text: 'Bruto Jaarsalaris', value: 'grossAnnualSalary' },
        { text: 'Loon voor Werknemersverzekeringen', value: 'svSalary' },
        { text: this.$t('employee.nature-of-employment'), value: 'natureOfEmployment' },
        { text: this.$t('employee.profession-classification'), value: 'professionClassification' },
        { text: this.$t('employee.no-risk'), value: 'noRisk' }
      ] : [
        { text: 'Ingangsdatum', value: 'fromDate' },
        { text: 'Bruto Jaarsalaris', value: 'grossAnnualSalary' },
        { text: this.$t('employee.nature-of-employment'), value: 'natureOfEmployment' },
        { text: this.$t('employee.profession-classification'), value: 'professionClassification' },
        { text: this.$t('employee.no-risk'), value: 'noRisk' }
      ];
    },
    isShowingExtras () {
      const policies = Compositions.getPoliciesFromParticipations(
        this.modalData.employee.allParticipations, this.$store.getters.policies);

      if (policies && policies.length > 0) {
        return _.some(policies, p => p.productType === 'WIA' || p.categoryType === 'INZETBAAR');
      }
      return false;
    }
  }
};
</script>
